import * as NavConst from '../components/constants/NavigationConstants';
import * as SweetAlert from '../components/common/utilities/ConfirmationAlert';
import {getApiPath, DELETE, ROLE, LIST } from '../api/ApiConst';

export const Role = {
  basePath: "role",
  tableDataUrl:LIST,
  label: "Role",
  attributes: [{ name: "id", value: "id", type: "text", position: 0, formAttribute: false },
  { name: "Name", value: "name", type: "text", position: 1, formAttribute: true, className: "form-control input-default" },
  { name: "Note", value: "note", type: "text", position: 3, formAttribute: true, className: "form-control input-default" },
  
  ],
  actions: [
    { name: "Edit", iconClass: "fa fa-edit", type: "model", navigatePath: NavConst.UPDATE_TABLE_STRUCTURE, replaceData: ":updateTableName" },
    {
      name: "Delete", iconClass: "fa fa-trash", type: "alert", action: (url, refresh) => SweetAlert.isDeleteRecord(url, refresh),
      navigatePath: getApiPath(ROLE, DELETE), replaceData: "{recordId}"
    },
    { name: "Active", iconClass: "fa fa-circle-check", type: "alert", action: SweetAlert.isActiveRecord },
    { name: "InActive", iconClass: "fa fa-circle-xmark", type: "alert", action: SweetAlert.isInActiveRecord },
  ]
};



